import { Injectable } from '@angular/core';
import { PaginationController } from '../../../models/pagination-controller.model';
import { ReetiquetadoFilters } from '../models/reetiquetado-filters.component';
import { ConsumosFilters } from '../models/consumos-filters.component';
import { EtiquetadoFilters } from '../models/etiquetado-filters.component';
import { MantenimientoConfeccionesFilters } from '../models/mantenimiento-confecciones-filters.component';
import { MantenimientoDesignacionesFilters } from '../models/mantenimiento-designaciones-filters.component';
import { MantenimientoEnvasesFilters } from '../models/mantenimiento-envases-filters.component';
import { MantenimientoEtiquetadoresFilters } from '../models/mantenimiento-etiquetadores-filters.compoent';
import { TotalesFilters } from '../models/totales-filters.component';
import { IncidenciaInfoFilters, MantenimientoIncidenciasFilters } from '../models/mantenimiento-incidencias-filters.component';
import { CultivosFilters } from '../models/cultivos-filters.component';
import { TrazabilidadEtiquetaFilters } from '../models/trazabilidad-etiqueta-filters.component';

@Injectable()
export class EtiquetadoContextService {
    public mantenimientoEtiquetadoresFilters: MantenimientoEtiquetadoresFilters;
    public mantenimientoDesignacionesFilters: MantenimientoDesignacionesFilters;
    public mantenimientoConfeccionesFilters: MantenimientoConfeccionesFilters;
    public confeccionesCajaFilters: PaginationController;
    public confeccionesPalletFilters: PaginationController;
    public mantenimientoEnvasesFilters: MantenimientoEnvasesFilters;
    public consumosFilters: ConsumosFilters;
    public etiquetadoFilters: EtiquetadoFilters;
    public reetiquetadoFilters: ReetiquetadoFilters;
    public totalesFilters: TotalesFilters;
    public mantenimientoIncidenciasFilters: MantenimientoIncidenciasFilters;
    public incidenciaInfoFilters: IncidenciaInfoFilters;
    public cultivosFilters: CultivosFilters;
    public trazabilidadEtiquetaFilters: TrazabilidadEtiquetaFilters;
}
